// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-icon-delete[data-v-01360bac] {\n  margin-left: 4px;\nspan {\n    margin-left: 4px;\n}\n}\n.el-icon-download[data-v-01360bac] {\n  margin-bottom: 10px\n}\n.contract-dialog[data-v-01360bac] {\n.contract-tag {\n    position: absolute;\n    right: 0;\n    top:70px;\n}\n}\n.status_btn[data-v-01360bac] {\n  font-size: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
